import { NgModule } from "@angular/core";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarAdminModule } from "./shared/navbar/navbar-admin/navbar-admin.module";
import { SuperAdminLayoutComponent } from "./layouts/superadmin/superadmin-layout.component";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AppRoutes } from "./app.routing";
import { SharedModule } from "./shared/shared.module";
import { PublicLayoutComponent } from "./layouts/public/public-layout.component";
import { DEFAULT_TIMEOUT, TokenInterceptor } from "./token.interceptor";
import { AuthService } from "app/core/services/auth.service";
import { ClientService } from "./core/services/client.service";
import { MasterClusterService } from "./core/services/master-cluster.service";
import { AdminService } from "./core/services/admin.service";
import { UserNoAdminService } from "./core/services/usernoadmin.service";
import { NoAdminLayoutComponent } from "./layouts/noadmin/noadmin-layout.component";
import { MasterFtpService } from "./core/services/master-ftp.service";
import { AlertService } from "./core/services/alert.service";
import { GroupService } from "./core/services/group.service";
import { NavbarSuperAdminModule } from "./shared/navbar/navbar-superadmin/navbar-superadmin.module";
import { SidebarModule } from "./sidebar/sidebar.module";
import { RoleService } from "./core/services/role.service";
import { VideoService } from "./core/services/video.service";
import { IncidentService } from "./core/services/incident.service";
import { DeviceService } from "./core/services/device.service";
import { ReportService } from "./core/services/report.service";
import { PermissionService } from "./core/services/permissions.service";
import { UserAdminService } from "./core/services/useradmin.service";
import { UserService } from "./core/services/user.service";
import { NouisliderModule } from "ng2-nouislider";
import { LoadingIndicatorService } from "./loading-indicator-service";
import { MapService } from "./core/services/map.service";
import { SharedVideoService } from "./core/services/shared-video.service";
import { MasterMainService } from "./core/services/master-main.service";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { DashboardService } from "./core/services/dashboard.service";
import { SharedIncidentService } from "./core/services/shared-incident.service";
import { CollectionService } from "./core/services/collection.service";
import { environment } from "../environments/environment";
import { ModalsComponentModule } from "./components/modals/modals.module";
import { VideoFootageService } from "./core/services/video-footage.service";
import { SharedVideoFootageService } from "./core/services/shared-video-footage.service";
import { UtilsDateService } from "./core/services/helpers/utils-date.service";
import { UtilsModalsService } from "./core/services/helpers/utils-modal.service";
import { BrowserModule } from "@angular/platform-browser";
import { UtilsRolesService } from "./core/services/helpers/roles.component";
import { NotificationService } from "./core/services/notification.service";
import { AssetService } from "./core/services/asset.service";
import { SystemService } from "./core/services/system.service";
import { CameraService } from "./core/services/camera.service";
import { PoliceStationService } from "./core/services/police-station.service";
import { InactivityService } from "./core/services/helpers/inactivity.service";
import { VideoRecordService } from "./core/services/video-record.service";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule.forRoot({
      defaultLanguage: AuthService.getFromStorage(
        environment.storageLanguageNameApi
      ),
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      scrollPositionRestoration: "enabled",
    }),

    NavbarAdminModule,
    NavbarSuperAdminModule,
    FooterModule,
    SidebarModule,
    SharedModule,
    HttpClientModule,
    NouisliderModule,
    ModalsComponentModule,
  ],
  declarations: [
    AppComponent,
    SuperAdminLayoutComponent,
    AdminLayoutComponent,
    NoAdminLayoutComponent,
    PublicLayoutComponent,
  ],
  providers: [
    AuthService,
    AdminService,
    UserAdminService,
    UserNoAdminService,
    MasterClusterService,
    UtilsModalsService,
    UtilsDateService,
    UtilsRolesService,
    ClientService,
    MasterFtpService,
    UserService,
    GroupService,
    RoleService,
    PoliceStationService,
    PermissionService,
    VideoService,
    SharedVideoService,
    MapService,
    IncidentService,
    SharedIncidentService,
    DeviceService,
    CameraService,
    VideoRecordService,
    AssetService,
    ReportService,
    AlertService,
    LoadingIndicatorService,
    MasterMainService,
    DashboardService,
    CollectionService,
    VideoFootageService,
    SharedVideoFootageService,
    NotificationService,
    SystemService,
    InactivityService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      // useFactory: (service: LoadingIndicatorService) => new TokenInterceptor(service,'a'),
      multi: true,
    },
    { provide: DEFAULT_TIMEOUT, useValue: 4000000 },
    // { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
